import * as Yup from "yup";
import { ImageApiUrl, PdfApiUrl } from "../../Helper/Additional";
export const today = new Date();
export const ageLimit = new Date(
  today.getFullYear() - 15,
  today.getMonth(),
  today.getDate()
);

export const validationSchema = Yup.object().shape({
  AuditorName: Yup.string().required("Name is required"),
  PanHolderName: Yup.string().required("Name is required"),
  // AuditorAge: Yup.string().required("Date of Birth is required"),
  // AuditorAge: Yup.date()
  // .notRequired()
  // .max(ageLimit, "Age must be above 15 years")
  // .typeError("Invalid date format"),
  AuditorGmail: Yup.string()
    .email("Invalid email")
    .required("Email is required"),
  AuditorContact: Yup.string()
    .required("Contact Number is required")
    // .matches(/^[0-9]{10}$/, "Invalid Contact Number"),
    .matches(/^[6-9]\d{9}$/, "Invalid Contact"),
  AuditorAddress: Yup.string().required("Address is required"),
  AuditorCountry: Yup.object().shape({
    value: Yup.string().required("Country is required"),
  }),
  gender: Yup.object().shape({
    value: Yup.string().required("Gender is required"),
  }),
 

  AuditorCity: Yup.object().shape({
    value: Yup.string().required("City is required"),
  }),
  AuditorState: Yup.object().shape({
    value: Yup.string().required("State is required"),
  }),
  AuditorPincode: Yup.string()
    .required("Pincode is required")
    .matches(/^[0-9]{6}$/, "Invalid Pincode"), // Ensure 6 digits
  AuditorQual: Yup.object().shape({
    value: Yup.string().required("Qualification is required"),
  }),
  TotalExperience: Yup.string().required("Total Experience is required"),
  ExperienceTrpw: Yup.string().notRequired(),
  WorkExperience: Yup.string().notRequired(),

  // IDProof: Yup.object().shape({
  //   value: Yup.string().required("ID proof is required"),
  // }),
  AddressProof: Yup.object().shape({
    value: Yup.string().required("Address proof is required"),
  }),
  identityProofFile: Yup.string().required("Document is required"),
  qualProofFile: Yup.string().required("Document is required"),
  // IdProofNumber: Yup.string().when("IDProof", {
  //   is: (IDProof) => IDProof?.value === "Aadhar",
  //   then: () =>
  //     Yup.string()
  //       .matches(/^\d{12}$/, "Aadhar number must be 12 digits")
  //       .required("Aadhar number is required"),
  //   otherwise: () =>
  //     Yup.string().when("IDProof", {
  //       is: (IDProof) => IDProof?.value === "Pancard",
  //       then: () =>
  //         Yup.string()
  //           .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Pancard number is invalid")
  //           .required("Pancard number is required"),
  //       otherwise: () =>
  //         Yup.string().when("IDProof", {
  //           is: (IDProof) => IDProof?.value === "Driving License",
  //           then: () =>
  //             Yup.string()
  //               .matches(
  //                 /^[A-Z]{2}[0-9]{13}$/,
  //                 "Driving License number is invalid"
  //               )
  //               .required("Driving License number is required"),
  //         }),
  //     }),
  // }),
  // IdProofNumber: Yup.string()
  //   .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Pancard number is invalid")
  //   .required("Pancard number is required"),

  // IdProofNumber: Yup.string()
  // .trim() 
  //   .matches(
  //     /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
  //     "Invalid. Must be 5 uppercase letters, 4 digits, 1 uppercase letter."
  //   )
  //   .required("Pancard number is required"),
   IdProofNumber: Yup.string()
    .matches(
      /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
      "Invalid,Must be 5 uppercase letters, 4 digits, 1 uppercase letter."
    )
    .test(
      "fourth-letter-p",
      "Invalid PAN number",
      (value) => {
        if (!value) return false; // Validation fails if the value is empty
        return value[3] === "P"; // Check if the 4th character is 'P'
      }
    )
    .required("PAN number is required"),

  // AddressProofNumber: Yup.string().when("AddressProof", {
  //   is: (AddressProof) => AddressProof?.value === "Aadhar",
  //   then: () =>
  //     Yup.string()
  //       .matches(/^\d{12}$/, "Aadhar number must be 12 digits")
  //       .required("Aadhar number is required"),
  //   otherwise: () =>
  //     Yup.string().when("AddressProof", {
  //       is: (AddressProof) => AddressProof?.value === "GST",
  //       then: () =>
  //         Yup.string()
  //           .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, "Invalid GST Number")
  //           .required("GST number is required"),
  //     }),
  // }),
  // AddressProofNumber: Yup.string().when("AddressProof", {
  //   is: (AddressProof) => AddressProof?.value === "Aadhar",
  //   then: () =>
  //     Yup.string()
  //       .matches(/^\d{12}$/, "Aadhar number must be 12 digits")
  //       .required("Aadhar number is required"),
  //   otherwise: () =>
  //     Yup.string().when("AddressProof", {
  //       is: (AddressProof) => AddressProof?.value === "GST",
  //       then: () =>
  //         Yup.string()
  //           .matches(
  //             /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
  //             "Invalid GST Number"
  //           )
  //           .required("GST number is required"),
  //       otherwise: () =>
  //         Yup.string().when("AddressProof", {
  //           is: (AddressProof) => AddressProof?.value === "Voter ID",
  //           then: () =>
  //             Yup.string()
  //               .matches(
  //                 /^[A-Z]{3}[0-9]{7}$/,
  //                 "Invalid Voter ID. Must follow format: 3 letters followed by 7 digits."
  //               )
  //               .required("Voter ID is required"),
  //           otherwise: () =>
  //             Yup.string().when("AddressProof", {
  //               is: (AddressProof) => AddressProof?.value === "Passport",
  //               then: () =>
  //                 Yup.string()
  //                   .matches(
  //                     /^[A-Z]{1}[0-9]{7}$/,
  //                     "Invalid Passport Number. Must follow format: 1 letter followed by 7 digits."
  //                   )
  //                   .required("Passport number is required"),
  //             }),
  //         }),
  //     }),
  // }),
  AddressProofNumber: Yup.string().when("AddressProof", {
    is: (AddressProof) => AddressProof?.value === "Aadhar",
    then: () =>
      Yup.string()
        .matches(/^\d{12}$/, "Aadhar number must be 12 digits")
        .required("Aadhar number is required"),
    otherwise: () =>
      Yup.string().when("AddressProof", {
        is: (AddressProof) => AddressProof?.value === "Water Bill",
        then: () =>
          Yup.string()
            .matches(/^\d{10}$/, "Water Bill number must be 10 digits")
            .required("Water Bill number is required"),
        otherwise: () =>
          Yup.string().when("AddressProof", {
            is: (AddressProof) => AddressProof?.value === "Electricity Bill",
            then: () =>
              Yup.string()
                .matches(
                  /^[A-Z0-9]{15}$/,
                  "Electricity Bill number must be 15 alphanumeric characters"
                )
                .required("Electricity Bill number is required"),
            otherwise: () =>
              Yup.string().when("AddressProof", {
                is: (AddressProof) => AddressProof?.value === "Passport",
                then: () =>
                  Yup.string()
                    .matches(
                      /^[A-Z]{1}[0-9]{7}$/,
                      "Invalid Passport number. Must start with 1 letter followed by 7 digits."
                    )
                    .required("Passport number is required"),
                otherwise: () =>
                  Yup.string().when("AddressProof", {
                    is: (AddressProof) => AddressProof?.value === "Voter ID",
                    then: () =>
                      Yup.string()
                        // .matches(
                        //   /^[A-Z]{3}[0-9]{7}$/,
                        //   "Invalid Voter ID. Must start with 3 letters followed by 7 digits."
                        // )
                        .required("Voter ID is required"),
                    otherwise: () =>
                      Yup.string().when("AddressProof", {
                        is: (AddressProof) =>
                          AddressProof?.value === "Driving License",
                        then: () =>
                          Yup.string()
                            // .matches(
                            //   /^[A-Z]{2}[0-9]{13}$/,
                            //   "Invalid . Must start with 2 letters followed by 13 digits."
                            // )
                            .required("Driving License is required"),
                      }),
                  }),
              }),
          }),
      }),
  }),

  AddressProofFile: Yup.string().required("Document is required"),
  //  resumeFile: Yup.string().required("Resume is required"),
  WorkCity: Yup.string().required("Enter work Preference city name"),

  WorkCity: Yup.array()
    .min(1, "Preference city is required")

    .of(
      Yup.object().shape({
        label: Yup.string().required("Enter work Preference city name"),
        value: Yup.string().required("Enter work Preference city name"),
      })
    ),
  //  SourceName: Yup.string().required("Source name is required"),
});

export const maskDocumentNumber = (number) => {
  if (!number) return "";
  const length = number.length;
  return length > 4
    ? "*".repeat(length - 4) + number.slice(length - 4)
    : number;
};

export const userStatus = [
 
  { value: "Approved", label: "Approved" },
  { value: "Contacted", label: "Contacted" },
  { value: "Employee", label: "Employee" },
  { value: "Pending", label: "Pending" },
  { value: "Rejected", label: "Rejected" },
  { value: "Blocked", label: "Blocked" },
];

export const docStatus = [
  { value: "All", label: "All" },
  { value: "0", label: "Pending" },
  { value: "1", label: "Submitted" },
  { value: "2", label: "Approved" },
];

export const idProof = [
  { value: "Aadhar", label: "Aadhar" },
  { value: "Pancard", label: "Pancard" },
  { value: "Driving License", label: "Driving License" },
];
export const gender = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  // { value: "others", label: "Others" },
];
export const usertype = [
  { value: "Seeker", label: "Seeker" },
  { value: "Auditor", label: "Auditor" },
];
export const addressProof = [
  { value: "Aadhar", label: "Aadhar" },
  // { value: "GST", label: "GST" },
  { value: "Driving License", label: "Driving License" },

  { value: "Voter ID", label: "Voter ID" },
  { value: "Passport", label: "Passport" },
];
export const Allqualification = [
  { value: "10th", label: "10th" },
  { value: "12th", label: "12th" },
  { value: "Diploma", label: "Diploma" },
  { value: "Graduation", label: "Graduation" },
  { value: "Post Graduation", label: "Post Graduation" },
  { value: "CA/CS/CMA Foundation", label: "CA/CS/CMA Foundation" },
  { value: "CA/CS/CMA Inter", label: "CA/CS/CMA Inter" },
  { value: "CA/CS/CMA Finalist", label: "CA/CS/CMA Finalist" },
  { value: "CA/CS/CMA", label: "CA/CS/CMA" },
];
// 1. CA/CS/CMA Foundation
// 2. CA/CS/CMA Inter
// 3. CA/CS/CMA Finalist
// 4. CA/CS/CMA

export function generatePassword(length) {
  var charset =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#*[]";
  var password = "";
  for (var i = 0; i < length; i++) {
    var randomIndex = Math.floor(Math.random() * charset.length);
    password += charset[randomIndex];
  }
  return password;
}

export const fileConverterHandler = async (File, ID, Name) => {
  const form = new FormData();

  form.append("file", File);
  form.append("foldername", "Job/Auditor");
  form.append("filename", `${Name}-${ID}`);

  let res = await fetch(PdfApiUrl, {
    method: "POST",
    body: form,
  });
  let result = await res.json();
  return result.Message.replace(process.env.REACT_APP_FILE_S3_PATH_URL, "");
};
